'use strict';

var PromiseUtils = require('./PromiseUtils'),
    noop = require('./noop');

function FileUploader(options) {
  this.uploadUrl = options.uploadUrl;
  this.data = options.data;
  this.key = options.key || 'file';
  this.transform = options.transform || (x => x);

  var maxSimultaneousUploads = options.maxSimultaneousUploads;
  if (maxSimultaneousUploads) {
    this.uploadFile = PromiseUtils.limitConcurrency(this.uploadFile, maxSimultaneousUploads);
  }
}

FileUploader.prototype = {
  uploadFiles: function (files) {
    files = Array.prototype.slice.call(files, 0);
    return files.map(this.uploadFile, this);
  },

  uploadFile: function (file, onProgress, cancellationToken) {
    var xhr,
        formData,
        prop,
        data = this.data,
        key = this.key,
        transform = this.transform;

    return new Promise((resolve, reject) => {
      if (!file.size) {
        return reject(new Error('Empty file size.'));
      }

      xhr = new window.XMLHttpRequest();
      formData = new window.FormData();

      if (cancellationToken) {
        cancellationToken.onCancelled(reason => {
          reject(reason);
          onProgress = noop;
          xhr.abort();
        });
      }

      xhr.open('POST', this.uploadUrl);

      xhr.upload.onloadstart = function () {
        onProgress(0);
      };

      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) {
          onProgress(e.loaded / e.total);
        }
      };

      xhr.onload = function (e) {
        try {
          resolve(transform(JSON.parse(e.target.responseText)));
        } catch (err) {
          reject(err);
        }
      };

      xhr.onerror = function (err) {
        reject(err);
      };

      if (data) {
        for (prop in data) {
          if (data.hasOwnProperty(prop)) {
            formData.append(prop, data[prop]);
          }
        }
      }

      formData.append(key, file);
      xhr.send(formData);
    });
  }
};

module.exports = FileUploader;


/** WEBPACK FOOTER **
 ** ./utils/FileUploader.js
 **/